import { injectable } from 'inversify';

import { ProfileAccessStorage } from '@vp/profile/core/interface/ProfileAccessStorage';

@injectable()
export class LocalProfileAccessStorage implements ProfileAccessStorage {
  async saveAccess(profileId: string, code: string): Promise<void> {
    const key = this.getKey(profileId);
    localStorage.setItem(key, code);
  }

  async getCode(profileId: string): Promise<string | null> {
    const key = this.getKey(profileId);
    return localStorage.getItem(key);
  }

  private getKey(id: string): string {
    return `profile-access-${id}`;
  }
}
